import React from 'react';
import { cn } from '../../../lib/utils';
import { LucideIcon } from 'lucide-react';
import { useIntersectionObserver, MockupContent, MockupDisplay } from './MockupUtils';

interface MockupData {
  type: string;
  icon: LucideIcon;
  description: string;
  mockup: React.ReactNode;
}

interface MockupItemProps {
  mockup: MockupData;
  index: number;
}

export const MockupItem: React.FC<MockupItemProps> = ({ mockup, index }) => {
  const [itemRef, isVisible] = useIntersectionObserver(0.2);
  const isEven = index % 2 === 0;

  return (
    <div
      ref={itemRef}
      className={cn(
        'flex flex-col lg:flex-row items-center gap-20',
        isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'
      )}
    >
      {/* Content */}
      <MockupContent
        title={mockup.type}
        description={mockup.description}
        icon={<mockup.icon size={32} className="text-blue-500" />}
        isEven={isEven}
        isVisible={isVisible}
      />

      {/* Mockup */}
      <MockupDisplay isEven={isEven} isVisible={isVisible}>
        {mockup.mockup}
      </MockupDisplay>
    </div>
  );
};